/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    encodeVisible: {
        cursor: 'pointer',
        textDecoration: 'underline'
    },
    greyOutlinedButton: {
        left: 0,
        fontFamily: 'GilmerMedium',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#40404B',
        height: theme.spacing(5),
        width: theme.spacing(10)
    },
    dialog: {
        borderRadius: theme.spacing(1.5)
    },
    dialogTitle: {
        textAlign: "center",
        paddingBottom: theme.spacing(0),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(1.5)
    },
    titleText: {
        lineHeight: '64px',
        fontFamily: 'GilmerBold',
        color: '#222228',
        fontSize: '29px'
    },
    action: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(2)
    },
    curlDescription: {
        fontFamily: 'Gilmer',
        fontSize: '15px',
        lineHeight: '24px',
        color: '#8D91A3',
        textAlign: 'center'
    },
    copyButton: {
        marginTop: theme.spacing(3)
    },
    contentWrapper: {
        display: 'flex'
    },
    code: {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(3),
        marginTop: theme.spacing(3),
        background: theme.palette.grey[200],
        color: '#da2316',
        flex: 1
    },
    command: {
        color: '#2b62b0'
    }
}));
